import API from 'services/API';

export default function getTaxExemptions() {
  return API.request({
    method: 'GET',
    url: '/taxpayer/taxExemptions',
  });
}
